jQuery(window).scroll(function() {
    checkOffsets();
});
checkOffsets();
function checkOffsets() {
    if (jQuery('.proplist-link').length) {
        var parentTop = jQuery('.proplist-link').parent().offset().top;
        if (jQuery(window).scrollTop() > parentTop) {
            jQuery('.proplist-link').addClass('stuck');
        } else {
            jQuery('.proplist-link').removeClass('stuck');
        }
    }
    if (jQuery(window).scrollTop() > 1000) {
        jQuery('.scrolltop:hidden').stop(true, true).fadeIn();
    } else {
        jQuery('.scrolltop').stop(true, true).fadeOut();
    }
}